<template>
  <div id="newsboard-manage">
    <button type="button" v-on:click="openAddEditModal()">DODAJ</button>
    <table class="newsboard-table">
      <thead>
        <tr>
          <th>BROJ</th>
          <th>PORUKA</th>
          <th>AKTIVNO</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr class="newsboard" v-for="(newsboard, index) in newsboardNotifications" v-bind:key="newsboard.id">
          <td>{{ index + 1 }}.</td>
          <td>{{ newsboard.text }}</td>
          <td>{{ newsboard.isActive }}</td>
          <td>
            <button type="button" v-on:click="openAddEditModal(newsboard)">UREDI</button>
            <button type="button" v-on:click="handleDelete(newsboard)">IZBRIŠI</button>
          </td>
        </tr>
      </tbody>
    </table>
    <AddEditNewsboardModal
      v-if="modalVisible"
      @close="closeModal"
      @afterSave="fetchNewsboardNotifications"
      :id="newsboardNotificationForModal.id"
      :text="newsboardNotificationForModal.text"
      :isActive="newsboardNotificationForModal.isActive"
    />
  </div>
</template>

<script>
import AddEditNewsboardModal from '@/components/admin/newsboard/AddEditNewsboardModal.vue';

export default {
  name: 'NewsboardManage',
  components: {
    AddEditNewsboardModal,
  },
  data() {
    return {
      newsboardNotifications: [],
      newsboardNotificationForModal: {},
      modalVisible: false,
    };
  },
  mounted() {
    this.fetchNewsboardNotifications();
  },
  methods: {
    openAddEditModal: function(newsboardNotification) {
      this.newsboardNotificationForModal = newsboardNotification ? newsboardNotification : {};
      this.modalVisible = true;
    },
    closeModal: function() {
      this.newsboardNotificationForModal = {};
      this.modalVisible = false;
    },
    handleDelete: function(newsboardNotification) {
      if (confirm(`Jeste li sigurni da želite izbrisati obavijest?`)) {
        this.$axios
          .delete(`${this.$API_URL}/newsboard/delete/${newsboardNotification.id}`)
          .then(this.fetchNewsboardNotifications)
          .catch(() => {
            alert('Brisanje neuspješno. Nevaljan unos ili zabranjen pristup.');
          });
      }
    },
    fetchNewsboardNotifications: function() {
      this.$axios.get(`${this.$API_URL}/newsboard/all`).then(response => {
        this.newsboardNotifications = response.data;
      });
    },
  },
};
</script>

<style scoped>
#newsboard-manage {
  color: white;
}

.newsboard-table {
  width: 100%;
  text-align: center;
}

button {
  padding: 6px;
}
</style>
